// extracted by mini-css-extract-plugin
export var selectContent = "Select-module--selectContent--66415";
export var selectIconColor = "Select-module--selectIconColor--3b53c";
export var selectItem = "Select-module--selectItem--382b2";
export var selectLabel = "Select-module--selectLabel--8657e";
export var selectTrigger = "Select-module--selectTrigger--705b7";
export var selectValue = "Select-module--selectValue--c5afa";
export var selectViewport = "Select-module--selectViewport--38b7c";
export var tickColor = "Select-module--tickColor--69881";